import { AxiosResponse } from 'axios';
import { api } from '../api';
import { GenericDeleteResponse, StandardResponse } from '../interfaces/Common';
import { PartialProgramFormRequest, Program, ProgramFormRequest } from '../interfaces/Program';

export async function getPrograms(): Promise<StandardResponse<Program[]>> {
    const response: AxiosResponse<StandardResponse<Program[]>> = await api.get("/programs");
    return response.data;
}

export async function createProgram(request: ProgramFormRequest): Promise<StandardResponse<Program>> {
    const response: AxiosResponse<StandardResponse<Program>> = await api.post("/programs", request);
    return response.data;
}

export async function updateProgram(programId: string, request: PartialProgramFormRequest): Promise<StandardResponse<Program>> {
    const response: AxiosResponse<StandardResponse<Program>> = await api.put(`/programs/${programId}`, request);
    return response.data;
}

export async function deleteProgram(programId: string): Promise<StandardResponse<GenericDeleteResponse>> {
    const response: AxiosResponse<StandardResponse<GenericDeleteResponse>> = await api.delete(`/programs/${programId}`);
    return response.data;
}